import useHomeData from "./Components/HomeData";
import HeroBanner from "./Components/HeroBanner";
import CustomerInfoSection from "./Components/CustomerInfoSection";
import ProtectionPlansSection from "./Components/ProtectionPlansSection";
import ProductDetailsSection from "./Components/ProductDetailsSection";
import UploadsSection from "./Components/UploadsSection";
import SummarySection from "./Components/SummarySection";
import "./index.scss";

const Home = () => {
  const homeData = useHomeData();

  return (
    <div className="warranty-page">
      <HeroBanner />

      <form className="wp-form" onSubmit={homeData.handleSubmit} noValidate>
        <CustomerInfoSection
          values={homeData.values}
          errors={homeData.errors}
          handleFieldChange={homeData.handleFieldChange}
          handleFieldBlur={homeData.handleFieldBlur}
        />

        <ProtectionPlansSection
          selectedPlan={homeData.selectedPlan}
          selectPlan={homeData.selectPlan}
        />

        <ProductDetailsSection
          values={homeData.values}
          errors={homeData.errors}
          handleFieldChange={homeData.handleFieldChange}
          handleFieldBlur={homeData.handleFieldBlur}
          planCategory={homeData.selectedPlan?.category || ""}
        />

        <UploadsSection
          invoiceFile={homeData.invoiceFile}
          invoiceError={homeData.invoiceError}
          isDragOver={homeData.isDragOver}
          onDrop={homeData.onDrop}
          onDragOver={homeData.onDragOver}
          onDragLeave={homeData.onDragLeave}
          onInvoiceInputChange={homeData.onInvoiceInputChange}
          videoRef={homeData.videoRef}
          isRecording={homeData.isRecording}
          hasRecordedVideo={homeData.hasRecordedVideo}
          recordedVideoUrl={homeData.recordedVideoUrl}
          videoError={homeData.videoError}
          cameraError={homeData.cameraError}
          cameraActive={homeData.cameraActive}
          handleRecordClick={homeData.handleRecordClick}
          handleVideoUpload={homeData.handleVideoUpload}
        />

        <SummarySection
          values={homeData.values}
          productLabel={homeData.productLabel}
          warrantySummary={homeData.warrantySummary}
          confirmChecked={homeData.confirmChecked}
          invoiceFileName={homeData.invoiceFile?.name || null}
          invoiceValue={homeData.values?.invoiceValue || ""}
          setConfirmChecked={homeData.setConfirmChecked}
          isSubmitting={homeData.isSubmitting}
          isFormReady={homeData.isFormReady}
        />
      </form>
    </div>
  );
};

export default Home;
